<div class="form-group d-flex">
    <input class="checkbox-input" *ngIf="isControlVisible()" [id]="getControlName()" [name]="getControlName()" [(ngModel)]="formValues[getName()]" [required]="isRequired()"
        type="checkbox" kendoCheckBox />
    <kendo-label *ngIf="isLabelVisible()" class="k-checkbox-label" [for]="getControlName()" [innerHtml]="getLabelHtml()">
    </kendo-label>
</div>